// extracted by mini-css-extract-plugin
export default {"backLink":"backLink_backLink__De8F8"};